import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  max-height: 10%;
  gap: 1rem;

  @media (max-width: 1200px) {
    gap: 0.5rem;
  }

  @media (max-width: 990px) {
    flex-direction: column;
    max-width: 90vw;
    display: flex;
    margin: 1rem auto;
  }
`;

export const Container = styled.div`
  width: 79%;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h1 {
      margin: 1rem 0;
      font-size: 1.5rem;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.secondary};
    }
  }

  @media (max-width: 1200px) {
    width: 69%;
  }

  @media (max-width: 990px) {
    width: -webkit-fill-available;
    padding: 0 1rem 1rem 1rem;
  }

  @media (max-width: 340px) {
    .header .titleSolicitation {
      font-size: 1.3rem;
    }
  }

  @media (max-width: 320px) {
    padding: 0 0.5rem 0.5rem 0.5rem;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 100rem;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 8px;
    background-color: ${({ theme }) => theme.colors.background_white};
    border-radius: 10px;
  }

  ::-webkit-scrollbar:horizontal {
    height: 5px;
  }

  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-track-horizontal {
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-thumb:horizontal {
    background-color: ${({ theme }) => theme.colors.tertiary_500};
    border-radius: 10px;
  }
`;
